
































































































































































import Vue from "vue";
import NavSideBar from "@/components/candidate/NavSideBar.vue";
import { process_tenant_registration } from "@/utils/principle_assessments";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  APP_ASSESSMENT_ANSWERS,
  APP_ASSESSMENT_QUESTIONNAIRES,
  CHAT_BOT_API
} from "@/store/modules/candidates/constants";
import {
  GET_USER_DETAILS,
  UPDATE_USER_DETAILS
} from "@/store/modules/auth/constants";
import { APP_ASSESSMENTS } from "@/store/modules/common/constants";
import { Assessment, List } from "@/interfaces/app_assessments";
import {
  AnswerPayload,
  CandidateJobInfoPayload,
  ChatBotPayload,
  ChatBotRoles,
  FetchAssessmentAnswersApiPayload,
  FetchAssessmentQuestionnariesPayload,
  QuestionnairePayload
} from "@/store/modules/candidates/interfaces";
import { wait_until } from "@/utils/global";
import JobSearchModal from "@/components/shared/jobs/JobSearchModal.vue";
import { ROOT_NOTIFICATION } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "CandidateWrapper",
  components: { NavSideBar, JobSearchModal },
  data() {
    return {
      chat_box_open: false, // Chat bot box open
      message: "" as string, // user message
      loading: false, // loading for question
      bot_content_loading: false, // loading for bot content
      ai_avatar: require("@/assets/images/AIAvatar.jpg"), // AI Avatar
      interview_history: [] as ChatBotPayload[], // Interview history
      assessment_id: 0 as number, // Assessment id
      total: 0 as number, // Total count
      total_questions: 0 as number, // Total questions
      page: 1 as number, // Page
      more_question_extract: false as boolean, // Is more question extract
      notice_content:
        "You do not need to apply specifically for the Job, only update the  profile after registration, your profile will automatically be considered for the Job",
      job_search_modal: false,
      screened_assessment_id: null as number | null
    };
  },
  created() {
    this.process_job_select_for_candidate();
  },
  async mounted() {
    this.bot_content_loading = true; // loading for bot content
    await process_tenant_registration(); // Process tenant registration
    const response = this.get_app_assessments;
    if (response) {
      const assessment_screened = response.find((assessment: Assessment) => {
        return assessment.assessment_type === List.JOB_SCREENING_QUESTIONS;
      });
      if (assessment_screened)
        this.screened_assessment_id = assessment_screened.id;
    }
    this.process_chat_bot();
  },
  computed: {
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    ...mapGetters("common", {
      get_app_assessments: APP_ASSESSMENTS
    }),
    ChatBotRoles() {
      return ChatBotRoles; // Chat bot roles
    },
    is_candidate_user_data_available(): boolean {
      const user_data = this.get_user_details.user_data;
      if (
        user_data &&
        (user_data.nationality || user_data.salary || user_data.notice_period)
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions("candidate", {
      chat_bot_api: CHAT_BOT_API,
      get_assessment_question: APP_ASSESSMENT_QUESTIONNAIRES,
      get_assessment_answer: APP_ASSESSMENT_ANSWERS
    }),
    ...mapActions("common", {
      app_assessments: APP_ASSESSMENTS
    }),
    ...mapActions("auth", {
      update_user_details: UPDATE_USER_DETAILS
    }),
    ...mapMutations({
      root_notification: ROOT_NOTIFICATION
    }),
    async chat_with_bot() {
      // Chat with bot
      if (this.message.length) {
        this.loading = true; // loading for question
        // Push user message
        this.interview_history.push({
          role: "USER",
          content: this.message,
          picture: ""
        });
        this.scroll_to_bottom();
        // Get bot answer
        const result = await this.chat_bot_api(this.message);
        this.message = "";
        // Push bot answer
        if (result) {
          this.loading = false;
          this.interview_history.push({
            role: "BOT",
            content: result.answer,
            picture: this.ai_avatar
          });
        } else {
          this.loading = false;
          // Push bot answer if not found
          this.interview_history.push({
            role: "BOT",
            content: "Sorry, Network error Please try again later.",
            picture: this.ai_avatar
          });
        }
        this.scroll_to_bottom();
      }
    },
    // Scroll to bottom to chat box
    async scroll_to_bottom() {
      // Wait for the refs
      await wait_until(100);
      // Scroll to bottom
      const scroll = this.$refs.scroll as HTMLElement;
      if (scroll) scroll.scrollTop = scroll.scrollHeight;
    },
    async init_chat_bot_history() {
      // Fetch assessment question
      const payload: FetchAssessmentQuestionnariesPayload = {
        assessment_id: this.assessment_id,
        page: this.page - 1,
        limit: 10,
        user_id: this.get_user_details.id
      };
      const question = await this.get_assessment_question(payload);
      // If History found
      if (question?.results) {
        const question_ids = question.results.map(
          (question: QuestionnairePayload) => question.id
        );
        this.total = question.total;
        this.total_questions += question.results.length;
        if (question_ids && question_ids.length > 0) {
          // Fetch assessment answer
          const answer: FetchAssessmentAnswersApiPayload = {
            assessment_id: this.assessment_id,
            page: 0,
            limit: 10,
            user_id: this.get_user_details.id,
            question_ids: question_ids
          };
          const answers = await this.get_assessment_answer(answer);
          if (answers?.results && answers.results?.length > 0) {
            // Reverse the array for the first time to show the latest question
            question.results = !this.more_question_extract
              ? question.results.reverse()
              : question.results;
            answers.results = !this.more_question_extract
              ? answers.results.reverse()
              : answers.results;

            question.results.map((question: QuestionnairePayload) => {
              const matched_result = answers.results.find(
                (answer: AnswerPayload) => answer.question_id === question.id
              );

              if (matched_result) {
                if (this.more_question_extract) {
                  // If extracting user by clicking load_more to add on top
                  this.interview_history.unshift({
                    role: ChatBotRoles.BOT,
                    content: matched_result.answer,
                    picture: this.ai_avatar
                  });
                  this.interview_history.unshift({
                    role: ChatBotRoles.USER,
                    content: question.question_text,
                    picture: ""
                  });
                } else {
                  this.interview_history.push({
                    role: ChatBotRoles.USER,
                    content: question.question_text,
                    picture: ""
                  });
                  this.interview_history.push({
                    role: ChatBotRoles.BOT,
                    content: matched_result.answer,
                    picture: this.ai_avatar
                  });
                }
              }
            });
          }
        }
        if (this.interview_history.length === 0) {
          this.interview_history.push({
            role: ChatBotRoles.BOT,
            content: "Hello, I am your AI bot. How can i help you?",
            picture: require("@/assets/images/AIAvatar.jpg")
          });
        }
        this.bot_content_loading = false; // loading for bot content
        if (!this.more_question_extract) this.scroll_to_bottom(); // Scroll to bottom
        this.more_question_extract = true;
      }
    },
    load_more() {
      this.bot_content_loading = true;
      this.page++;
      this.init_chat_bot_history();
    },
    handle_enter(event: KeyboardEvent) {
      if (event.shiftKey) return;
      this.chat_with_bot();
    },
    async process_chat_bot() {
      const response = this.get_app_assessments;
      if (response) {
        const chat_bot = response.find((assessment: Assessment) => {
          return assessment.assessment_type === List.CHAT_BOT_MESSAGES;
        });
        if (chat_bot) {
          this.assessment_id = chat_bot.id;
          this.init_chat_bot_history();
        } else {
          this.interview_history.push({
            role: ChatBotRoles.BOT,
            content:
              "Apologies, the chat bot is currently unavailable. Please try again later.",
            picture: this.ai_avatar
          });
        }
      } // Get chat bot
      else {
        this.bot_content_loading = false;
        this.interview_history.push({
          role: ChatBotRoles.BOT,
          content:
            "Apologies, the chat bot is currently unavailable. Please try again later.",
          picture: this.ai_avatar
        });
      }
    },
    process_job_select_for_candidate() {
      if (
        this.get_user_details.user_data &&
        this.get_user_details.user_data.candidate_disclaimer
      ) {
        this.job_search_modal = false;
      } else this.job_search_modal = true;
    },
    async continue_process(process_data: CandidateJobInfoPayload | null) {
      this.job_search_modal = false;
      // User Data
      let user_data = {
        ...this.get_user_details.user_data,
        candidate_disclaimer: true
      };
      if (process_data) {
        user_data = {
          ...user_data,
          ...process_data
        };
      }

      const response = await this.update_user_details({ user_data });
      if (response) {
        this.root_notification("Data Upload Successfully");
      }
    }
  }
});
